// components/Molecules/ScrollableCard/ScrollableCard.js
import PropTypes from 'prop-types';
import Icon from '../../Atoms/Icon/Icon'
import { Card, Image, Link } from '../../Atoms';

const ScrollableCard = ({
  title,
  subtitle,
  image,
  href,
  className = '',
}) => {
  return (
    <Link href={href} className="block no-underline">
      <Card usage="interactive" className={`card-scrollable ${className}`}>
        <div className="block">
          
          <div className="block__header">
            {image ? (
              <Image image={image} fit="cover" />
            ) : (
              <div className="flex items-center justify-center h-full bg-gradient-to-br from-primary/20 to-accent/20">
                <Icon name="file" size="4xl" className="text-neutralMedium" />
              </div>
            )}
          </div>
          
          <div className="block__body">
            <div className="stack stack-tight">
              <div className="text-item-title line-clamp-2">{title}</div>
              {subtitle && <div className="text-body-sm line-clamp-2">{subtitle}</div>}
            </div>
          </div>
          
        </div>
      </Card>
    </Link>
  );
};

ScrollableCard.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  image: PropTypes.object,
  href: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default ScrollableCard;